module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_Frame06-6d0c47d841c718a881630dfcb78b6858.png";